import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

export namespace DockJumping {
  export const getForm = (show: IShow): IEventRegisterRow[] => {
    // Helper function to check if an element/level is available in the show
    const isElementAvailable = (elementOrLevel: string): boolean => {
      if (!show?.show_elements) return true; // If no show provided, show all options
      
      return show.show_elements.some(se => 
        se.show_element === elementOrLevel || se.level === elementOrLevel
      );
    };

    const formRows: IEventRegisterRow[] = [];

    // Only add Air element if it's available in the show
    if (isElementAvailable(Constants.dog_class_element.dock_jumping_air)) {
      // Get splash count from the Air element
      const airElement = show.show_elements.find(element => 
        element.show_element === Constants.dog_class_element.dock_jumping_air
      );
      const splashCount = airElement?.splash_count || 6; // Default to 6 if not specified
      
      // Create splash options based on the show's splash count
      const splashOptions = [];
      for (let i = 1; i <= splashCount; i++) {
        splashOptions.push({
          value: Constants.dog_class_element_level[`dock_jumping_splash_${i}` as keyof typeof Constants.dog_class_element_level],
          id: Constants.dog_class_element_level[`dock_jumping_splash_${i}` as keyof typeof Constants.dog_class_element_level],
        });
      }

      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.dock_jumping_air,
            multiSelect: true,
            options: splashOptions,
          },
        ],
      });
    }

    // Only add Fetch It element if it's available in the show
    if (isElementAvailable(Constants.dog_class_element.dock_jumping_fetch_it)) {
      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.dock_jumping_fetch_it,
            multiSelect: true,
            options: [
              {
                value: Constants.dog_class_element_level.dock_jumping_fetch_it,
                id: Constants.dog_class_element_level.dock_jumping_fetch_it,
              },
            ],
          },
        ],
      });
    }

    // Only add Vertical element if it's available in the show
    if (isElementAvailable(Constants.dog_class_element.dock_jumping_vertical)) {
      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.dock_jumping_vertical,
            multiSelect: true,
            options: [
              {
                value: Constants.dog_class_element_level.dock_jumping_vertical,
                id: Constants.dog_class_element_level.dock_jumping_vertical,
              },
            ],
          },
        ],
      });
    }

    // Only add Raider Run element if it's available in the show
    if (isElementAvailable(Constants.dog_class_element.dock_jumping_raider_run)) {
      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.dock_jumping_raider_run,
            multiSelect: true,
            options: [
              {
                value: Constants.dog_class_element_level.dock_jumping_raider_run,
                id: Constants.dog_class_element_level.dock_jumping_raider_run,
              },
            ],
          },
        ],
      });
    }

    return formRows;
  };
}
